export default [
  {
    path: "list",
    component: (resolve) => require(["../views/active/list.vue"], resolve),
  },
  {
    path: "banner",
    component: (resolve) => require(["../views/active/banner.vue"], resolve),
  },
  {
    path: "subject",
    name: "subject",
    component: (resolve) => require(["../views/active/subject.vue"], resolve),
  },
  {
    path: "template",
    component: (resolve) =>
      require(["../views/active/ListTemplate.vue"], resolve),
  },
  {
    path: "type",
    component: (resolve) => require(["../views/active/type.vue"], resolve),
  },
  {
    path: "recycle",
    component: (resolve) => require(["../views/active/recycle.vue"], resolve),
  },
  {
    path: "livereport",
    component: (resolve) => require(["../views/active/LiveData.vue"], resolve),
  },
  {
    path: "activereport",
    component: (resolve) =>
      require(["../views/active/ActiveReport.vue"], resolve),
  },
  {
    path: "activecompany",
    component: (resolve) =>
      require(["../views/active/ActiveCompany.vue"], resolve),
  },
  {
    path: "activeReportForms",
    component: (resolve) =>
      require(["../views/active/ActiveReportForms.vue"], resolve),
  },
  {
    path: "activeSession",
    component: (resolve) =>
      require(["../views/active/ActiveSession.vue"], resolve),
  },
  {
    path: "activePeopleNum",
    component: (resolve) =>
      require(["../views/active/ActivePeopleNum.vue"], resolve),
  },
  {
    path: "livereport/detail/:id",
    component: (resolve) =>
      require(["../views/active/LiveDataDetail.vue"], resolve),
  },
  {
    path: "service",
    component: (resolve) =>
      require(["../views/active/AddService.vue"], resolve),
  },
];
